import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RoleSummaryDTO, RegisterRoleRequest, RoleDetailDTO } from '../interfaces/roles.interfaces';
import { environment } from 'src/environments/enviroments';
import { HttpClient } from '@angular/common/http';
import { AssignRolePermissionRequestDTO, PermissionDTO, RevokeRolePermissionRequestDTO } from '../interfaces/permission.interface';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private httpClient: HttpClient) { }

  getAllRoles(): Observable<Array<RoleSummaryDTO>> {
    const endpoint = `${environment.apiUrl}/roles`;
    return this.httpClient.get<Array<RoleSummaryDTO>>(endpoint);
  }

  getRoleById(id: number): Observable<RoleDetailDTO>{
    const endpoint = `${environment.apiUrl}/roles/${id}`;
    return this.httpClient.get<RoleDetailDTO>(endpoint);
  }

  getAllPermissions(): Observable<Array<PermissionDTO>>{
    const endpoint = `${environment.apiUrl}/roles/permissions`;
    return this.httpClient.get<Array<PermissionDTO>>(endpoint);
  }

  registerRole(request: RegisterRoleRequest): Observable<ActionResponseDTO<number | null>>{
    const endpoint = `${environment.apiUrl}/roles`;
    return this.httpClient.post<ActionResponseDTO<number | null>>(endpoint, request);
  }

  /**
   * Metodo para enviar solicitud API para asignar permisos a un rol
   * @param request interfaz de body de solicitud
   * @returns respuesta de API que entrega detalle de la operacion
   */
  assignRolePermissions(request: AssignRolePermissionRequestDTO): Observable<ActionResponseDTO<boolean>>{
    const endpoint = `${environment.apiUrl}/roles/${request.roleId}/permissions/assign`;
    return this.httpClient.put<ActionResponseDTO<boolean>>(endpoint, request);
  }

    /**
   * Metodo para enviar solicitud API para quitar permisos a un rol
   * @param request interfaz de body de solicitud
   * @returns respuesta de API que entrega detalle de la operacion
   */
  revokeRolePermissions(request: RevokeRolePermissionRequestDTO): Observable<ActionResponseDTO<boolean>>{
    const endpoint = `${environment.apiUrl}/roles/${request.roleId}/permissions/revoke`;
    return this.httpClient.put<ActionResponseDTO<boolean>>(endpoint, request);
  }

  /**
   * Metodo para enviar solicitud API para obtener permisos que no tiene asignado un rol
   * @param roleId Id de rol
   * @returns Observable con listado de permisos que no tiene el rol
   */
  getUnassignedPermissionsRole(roleId:number): Observable<Array<PermissionDTO>> {
    const endpoint = `${environment.apiUrl}/roles/${roleId}/permissions/unassigned`;
    return this.httpClient.get<Array<PermissionDTO>>(endpoint);
  }
}
